export const STATUS_LABEL_MAP: Record<string, string> = {
  ACTIVE: "ATIVO",
  INACTIVE: "INATIVO",
  CREATED: "CRIADO",
  BLOCKED: "BLOQUEADO",
};

export const STATUS_OPTIONS = [
  { label: "ATIVO", value: "ACTIVE" },
  { label: "BLOQUEADO", value: "BLOCKED" },
  { label: "INATIVO", value: "INACTIVE" },
];
